import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SocialMediaConstants, MixpanelEventName } from '../common/Constants';
import Classes from '../common/Classes';
import MixPanelHelper from '../common/MixPanelHelper';

const ReadOnlySocialMedia = ({
  tag, socialMedia = [], translations, participantId
}) => {
  const applyOpacity = (socialMediaUrl) => (socialMediaUrl
    ? Classes.withoutOpacity : Classes.withOpacity);

  const handleClick = (event, eventName, interactedElement) => {
    let interactedElementInTitleCase = interactedElement.toLowerCase();
    interactedElementInTitleCase = interactedElementInTitleCase.charAt(0).toUpperCase() + interactedElementInTitleCase.slice(1);
    MixPanelHelper.trackInteractedEvents(eventName, participantId, interactedElementInTitleCase);
  };

  return (
    <div className={Classes.socialMedia.readOnly}>
      {socialMedia.map((category) => (
        <a
          onClick={(e) => {
            handleClick(e, MixpanelEventName.ParticipantInteracted, category.socialMediaType);
          }}
          key={category.socialMediaType}
          data-dtm={tag[category.socialMediaType]}
          href={category.url || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className={classnames(
            Classes.socialMediaLogoColor[category.socialMediaType],
            Classes.socialMediaLogo,
            Classes.textCenter,
            applyOpacity(category.url)
          )}
          disabled={category.url.length === 0}
        >
          <svg width="40px" height="40px" viewBox="0 0 14 14" className={Classes.centerBlock}>
            <path
              d={SocialMediaConstants[category.socialMediaType]}
            />
          </svg>
          <span className={Classes.centerBlock}>
            {translations[category.socialMediaType].viewLabel}
          </span>
        </a>
      ))}
    </div>
  );
};

ReadOnlySocialMedia.propTypes = {
  tag: PropTypes.object.isRequired,
  socialMedia: PropTypes.array,
  translations: PropTypes.object.isRequired,
  participantId: PropTypes.string
};

export default ReadOnlySocialMedia;
